import {
  SHIPPING_LIST_REQUESTING,
  LIST_SHIPPING_SUCCESS,
  RESET_SHIPPING_ISFETCHING,
  RESET_SHIPPING_QUERY,
  LIST_SHIPPING_AVAILABILITY_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: null,
  isListFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_SHIPPING_ISFETCHING: {
      return {
        ...state,
        isListFetching: false
      };
    }
    case RESET_SHIPPING_QUERY: {
      return {
        ...state,
        query: null
      };
    }
    case SHIPPING_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_SHIPPING_SUCCESS: {
      const data = { ...state.data };
      let isUsingAppShipping;
      const query = [];

      action.payload.forEach((object) => {
        if (object?.vendor === 'Local') {
          isUsingAppShipping = false;
        } else {
          isUsingAppShipping = true;
        }
        data.isUsingAppShipping = isUsingAppShipping;
        let id = object.id;
        // external shipping apps do not have ids, so we use the title as the identifier
        if (isUsingAppShipping) {
          id = object.title;
        }

        data[id] = object;
        query.push(id);
      });
      return {
        ...state,
        data,
        query,
        isListFetching: false
      };
    }
    case LIST_SHIPPING_AVAILABILITY_SUCCESS: {
      const availability = action.payload;
      const data = { ...state.data, availability };

      return {
        ...state,
        data,
        isListFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
